import { Card, CardContent, CardDescription, CardHeader, CardMeta, Image } from "semantic-ui-react";
import styles from './TrufflePage.module.css';

export default function CardTruffle4() {
    return (
        <Card fluid className={styles.cardShadow}>
            <CardContent>
                <CardHeader>Fresh White Truffle - Tuber Borchii</CardHeader>
                <CardMeta>
                    <Image src="/assets/borches.png" fluid centered />
                </CardMeta>
                <CardDescription>

                </CardDescription>
            </CardContent>
            <CardContent extra>
                <span className={styles.price}>500 </span> - <span className={styles.price}>1000 </span>
            </CardContent>
        </Card >
    )
}